import { render, staticRenderFns } from "./404-mantain.vue?vue&type=template&id=44e6e286&"
import script from "./404-mantain.vue?vue&type=script&lang=ts&"
export * from "./404-mantain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports